import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import "@studycoach/design-tokens/tokens.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("StudyCoach web root is missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
